module.exports = __webpack_public_path__ + "static/media/munch11.ce58a895.wav";